import { csvMoney, csvRate } from '../csvValues';

import type { ForecastRow, HistoryRow } from './model';
import { offerGroups, scoreGroups } from './model';

type Scope = {
  tab: string;
  pipeline: ForecastRow[];
  offers: ReturnType<typeof offerGroups>;
  countryRows: ReturnType<typeof scoreGroups>;
  allTime: HistoryRow[];
  compareRows: HistoryRow[];
  nearRows: HistoryRow[];
};
/** Export full evidence populations; visual table pagination is deliberately absent. Margins are rounded to
 * the cent and scores and performance levels to six places. */
export function supplyCsvRows({
  tab,
  pipeline,
  offers,
  countryRows,
  allTime,
  compareRows,
  nearRows,
}: Scope): unknown[][] {
  const rows: unknown[][] = [];
  if (tab === 'scores') {
    rows.push(
      // Same first four columns, in the same order, as the page's country table.
      ['Country', 'Supply score', 'Supply index', 'Expected margin', 'Actual margin', 'Top historic week margin'],
      ...countryRows.map((r) => [
        r.country,
        csvRate(r.score),
        r.rank,
        csvMoney(r.expected),
        csvMoney(r.actual),
        csvMoney(r.baseline),
      ]),
      [],
      ['Country', 'Tier', 'Vendor', 'Date', 'Actual margin', 'Expected margin', 'Performance level'],
    );
    offers.forEach((r) =>
      r.rows.forEach((d) =>
        rows.push([
          r.country,
          r.tier,
          r.vendor,
          d.date_axis,
          csvMoney(d.actual_margin),
          csvMoney(d.expected_margin),
          csvRate(d.actual_margin !== null && d.expected_margin ? d.actual_margin / d.expected_margin : null),
        ]),
      ),
    );
  } else {
    rows.push([
      'Country',
      'Website region',
      'Vendor',
      'Tier',
      'Date',
      'Actual margin',
      'Expected margin',
      'Actual and predicted margin',
    ]);
    (tab === 'pipeline' ? pipeline : []).forEach((r) =>
      rows.push([
        r.offer_country_name,
        r.offer_region,
        r.vendor_name,
        r.tier,
        r.date_axis,
        csvMoney(r.actual_margin),
        csvMoney(r.expected_margin),
        csvMoney(r.blended_margin),
      ]),
    );
  }
  if (tab === 'pipeline')
    rows.push(
      [],
      ['All time Sydney date', 'Actual margin before today', 'Expected margin', 'Actual and predicted margin'],
      ...allTime.map((r) => [
        r.date_axis,
        csvMoney(r.actual_past),
        csvMoney(r.expected_margin),
        csvMoney(r.blended_margin),
      ]),
    );
  if (tab === 'pipeline')
    rows.push(
      [],
      ['Days after today Sydney date', 'Actual margin before today', 'Expected margin', 'Actual and predicted margin'],
      ...nearRows.map((r) => [
        r.date_axis,
        csvMoney(r.actual_past),
        csvMoney(r.expected_margin),
        csvMoney(r.blended_margin),
      ]),
    );
  if (tab === 'comparison') {
    rows.push(
      [],
      ['Sydney date', 'Actual margin before today', 'Expected margin', 'Actual and predicted margin'],
      ...compareRows.map((r) => [
        r.date_axis,
        csvMoney(r.actual_past),
        csvMoney(r.expected_margin),
        csvMoney(r.blended_margin),
      ]),
    );
  }
  return rows;
}
